import React, { useState, useEffect } from "react";
import Button from "../../shared/button";
import Badge from "../../shared/badge";
import Chatbot from "../chatbot/chatbot";
import { useTranslation } from "react-i18next";

const Banner = () => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [animationClass, setAnimationClass] = useState("word-enter");
  const { t } = useTranslation();
  const [isVideoVisible, setIsVideoVisible] = useState(false);

  const toggleVideo = () => {
    setIsVideoVisible((prevState) => !prevState);
  };

  const words = [
    t("home.banner.one"),
    t("home.banner.two"),
    t("home.banner.three"),
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimationClass("word-exit");
      setTimeout(() => {
        setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
        setAnimationClass("word-enter");
      }, 1000);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div
        id="home"
        className="relative w-[100%] rounded-bl-[38px] rounded-br-[38px] rounded-tl-none rounded-tr-none bg-[#F0F2F4]"
      >
        <div className="pt-[280px] max-md:pt-[80px]  max-w-[80%] max-xxxl:max-w-[90%] w-full m-auto pb-[250px] sm-s:pb-[80px]">
          <div className="mx-auto md:px-0 flex flex-col md:flex-row items-center md-m:flex-col md-m:items-start max-sm:gap-[20px]">
            {/* Left Section */}
            <div className="w-[45%] md-m:w-[67%] max-sm:!w-[100%]">
              <Badge txt={t("home.banner.title")} />
              <h1 className="heading-color  font-normal font-sora">
                {t("home.banner.subtitle")}
              </h1>
              <div className="relative">
                <h1
                  className={`words font-sora heading-color md:text-[60px] uppercase font-normal ${animationClass}`}
                >
                  {words[currentWordIndex]}
                </h1>
              </div>

              <div className="max-w-[90%] sm-s:max-w-full flex justify-between mt-[20px] rounded-[50px] bg-white backdrop-blur-[7.5px] pl-[32px]">
                <input
                  className="text-[#9C9C9C] font-manrope text-[16px] font-medium leading-[15px]"
                  type="email"
                  placeholder={t("home.banner.inputPlaceholder")}
                />
                <Button
                  text={t("home.banner.button")}
                  className="button btn-light-black"
                  height={60}
                  width={280}
                />
              </div>

              <h6 className="txt-color font-manrope mt-[25px] max-w-[433px]">
                {t("home.banner.desc")}
              </h6>
              <div className="flex items-center space-x-2 pt-4">
                <div className="flex -space-x-2">
                  <img
                    src="../../assets/images/home/users.png"
                    alt="users"
                    className="w-[83px] h-[60px]"
                  />
                </div>
                <div className="text-yellow-500">★★★★★</div>
                <p className="e-small font-manrope font-medium tex-grey">
                  {t("home.banner.users")}
                </p>
              </div>
            </div>

            {/* Right Section */}
            <div className="w-[65%] flex flex-col gap-[11px] md-m:w-[100%] h-fit">
              <div className="relative">
                {/* Initially visible Image */}
                {!isVideoVisible ? (
                  <img
                    src="../../assets/images/home/banner-bg.png"
                    alt="Banner Image"
                    className="w-full drop-shadow-md h-[445px]"
                  />
                ) : (
                  // Video Section
                  <div
                    className={`video-section bg-[#E6E6E6] shadow-[0px_0px_10.9px_0px_rgba(0,_4,_47,_0.15)] rounded-[25px] overflow-hidden h-[445px] w-full relative z-[2] transition-opacity duration-300`}
                  >
                    <video
                      className="max-w-full w-full object-cover h-[445px] z-[1]"
                      loop
                      playsInline
                      preload="auto"
                      autoPlay
                      onClick={() => {
                        // Toggle play/pause on video click
                        const video = document.querySelector("video");
                        if (video) video.paused ? video.play() : video.pause();
                      }}
                    >
                      <source
                        src="../../assets/videos/intro.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                )}

                {/* Button to Toggle Video/Image */}
                <div
                  className="absolute bg-[#E6E6E6] p-[20px] cursor-pointer drop-shadow-md rounded-[25px] right-[15px] bottom-[11px] flex items-center gap-[15px] z-[3]"
                  onClick={toggleVideo}
                >
                  <img
                    src={
                      isVideoVisible
                        ? "../../assets/icons/pause-btn.png"
                        : "../../assets/icons/play.png"
                    }
                    alt={isVideoVisible ? "Pause Icon" : "Play Icon"}
                    className="cursor-pointer "
                  />
                  <p className="medium tex-grey font-semibold cursor-pointer">
                    {isVideoVisible ? "Pause video" : "Watch video"}
                  </p>
                </div>
              </div>

              <div className="gap-[16px] flex sm-s:flex-col">
                {/* Other Components */}
                <div className="relative h-[191px] z-[2] sm-s:max-w-full max-w-[65%] w-full overflow-hidden flex justify-between rounded-[21px] bg-black py-[27px] pr-[3px] pl-[24px]">
                  <div className="relative z-[1]">
                    <h5 className=" text-white font-manrope leading-[25.271px] font-medium max-w-[186px]">
                      {t("home.banner.cardOne.title")}
                    </h5>
                    <div className="flex items-center space-x-1 pt-3">
                      <div className="text-yellow-500">★★★★★</div>
                      <p className="e-small font-manrope font-medium text-white">
                        {t("home.banner.cardOne.users")}
                      </p>
                    </div>
                  </div>
                  <div className="mt-[15px] relative z-[1]">
                    <img
                      src="../../assets/gifs/lines.gif"
                      alt="Lines Animation"
                      className="w-[100%] h-[122px]"
                    />
                  </div>
                  <div className="absolute banner-blue-back w-[287px] h-[287px] top-[-75px] left-[-60px] z-[-1]"></div>
                </div>

                <div className="reminder-div sm-s:max-w-full bg-white overflow-hidden h-[191px] max-w-[35%] max-h-full w-full rounded-[21px] flex flex-col justify-center relative">
                  <img
                    src="../../assets/images/home/clock.png"
                    alt="Clock"
                    className="rounded-bg z-[1] absolute bottom-[-2%] right-[-1%] w-[175px] h-[175px]"
                  />
                  <h1 className="text-[#38404C] font-semibold text-[34px] px-[17px] z-[1]">
                    {t("home.banner.cardTwo.title")}
                  </h1>
                  <h5 className="text-[#38404C] font-semibold px-[17px] z-[1]">
                    {t("home.banner.cardTwo.users")}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Chatbot />
    </>
  );
};

export default Banner;
